import styled from 'styled-components/macro';

export const StyledCreditCard = styled.div`
  display: flex;
  align-items: center;
`;
